import { jsx as _jsx } from "react/jsx-runtime";
export function ResponseHeaders({ response }) {
    let headers = '';
    response.headers.forEach((value, key) => {
        headers += `${key}: ${value}\n`;
    });
    return (_jsx("div", { children: _jsx("pre", { className: "overflow-x-scroll p-2 text-xs text-zinc-600 dark:text-white/60", children: _jsx("code", { children: headers }) }) }));
}
